/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/application",
    "component!base",
    "i18n/i18n",
    "utils/dom",
    "utils/keys",
    "utils/timer",
    "jquery",
    "underscore"
  ],
  function (
    Application,
    Base,
    i18n,
    dom,
    keys,
    timer,
    $,
    _
  ) {

    /* Base extensions */
    Base.prototype.events = _.extend({
      "contextmenu": "abortContextMenu",
      "focusin *:has( > [data-edit]),.mb-inplace-editable": "updateHasPopup",
      "keydown *:has( > [data-edit]),.mb-inplace-editable": "showInPlaceEditHandleOnMenuKey",
      "keypress *:has( > [data-edit]),.mb-inplace-editable": "abortMenuKey",
      "keyup *:has( > [data-edit]),.mb-inplace-editable": "abortMenuKey",
      "mouseenter *:has( > [data-edit]),.mb-inplace-editable": "showInPlaceEditHandle",
      "mouseleave *:has( > [data-edit]),.mb-inplace-editable": "hideInPlaceEditHandle"
    }, Base.prototype.events);

    Base.prototype.updateHasPopup = function (e) {
      $(e.currentTarget).attr("aria-haspopup", "true");
    };

    Base.prototype.abortContextMenu = function (e) {
      if (this._abortContextMenu) {
        e.stopPropagation();
        e.preventDefault();
        delete this._abortContextMenu
      }
    }

    Base.prototype.abortMenuKey = function (e) {
      if (e.which === keys.f10 && e.shiftKey || e.which === keys.menu) {
        this._abortContextMenu = e.which === keys.menu;
        e.stopPropagation();
        e.preventDefault();
      }
    };

    Base.prototype.showInPlaceEditHandleOnMenuKey = function (e, traceContext) {
      if (e.which === keys.f2) {
        this.options.application.inplaceEdit({
          targetEl: e.currentTarget,
          model: this.model,
          deletable: true
        });
      } else if (e.which === keys.f10 && e.shiftKey || e.which === keys.menu) {
        this._abortContextMenu = e.which === keys.menu;
        this.showInPlaceEditHandle(e, traceContext, true, "key");
        e.stopPropagation();
        e.preventDefault();
      } else if (e.which === keys["delete"]) {
        this.model.destroy();
      }
    };

    var originalInitialize = Base.prototype.initialize;
    Base.prototype.initialize = function () {
      var that = this;

      originalInitialize.apply(this, arguments);

      this.showInPlaceEditHandle = timer.delayedThrottled(function (e, traceContext, focus, hideEventMask) {
          var $target = $(e.currentTarget),
              application = this.options.application;

          if ($target.children("[data-edit]").length < 1) return;

          if (application.inplaceEditHandleEl && application.inplaceEditHandleEl.parentNode === e.currentTarget) return;

          that.hideEventMask = hideEventMask;

          $target.addClass("mb-inplace-editable");
          this.removeInPlaceEditHandle();

          application.inplaceEditHandleEl = document.createElement("span");
          application.inplaceEditHandleEl.setAttribute("role", "menu");
          application.inplaceEditHandleEl.className = "mb-role";
          var button = document.createElement("button");
          button.className = "action mb-inplace-handle mb-inplace-action mb-btn-no-decor mb-acc-pencil";
          button.setAttribute("role", "menuitem");
          button.setAttribute("title", i18n("editor_edit", [""]));
          button.setAttribute("data-action-object", JSON.stringify({ inplaceEdit: { deletable: true }}));
          button.innerHTML = '<span><i class="icon-pencil"></i><span class="mb-acc">' + i18n("editor_edit", [""]) + '"</span></span>';
          application.inplaceEditHandleEl.appendChild(button);
          $(application.inplaceEditHandleEl).on("menuclose", function () {
            that.removeInPlaceEditHandle();
            dom.focus($target, true);
          });

          $target.append(application.inplaceEditHandleEl);
          if (focus) {
            button.focus();
          }
        }, 0);
    }

    Base.prototype.hideInPlaceEditHandle = function (e) {
      if (!this.hideEventMask || new RegExp(this.hideEventMask).test(e.type)) {
        this.showInPlaceEditHandle.abort();
        this.removeInPlaceEditHandle();
      }
    }

    Base.prototype.removeInPlaceEditHandle = function () {
      delete this.hideEventMask;
      var $inplaceEditHandle = $(this.options.application.inplaceEditHandleEl);
      $inplaceEditHandle.remove()
      delete this.options.application.inplaceEditHandleEl;
    }

    /* Application extensions */
    Application.prototype.inplaceEdit = function (options) {
      var targetEl = options.targetEl || $(options.eventTarget).closest(options.eventTarget.getAttribute("data-inplace-selector") || ".mb-inplace-editable")[0],
          $targetEl = $(targetEl),
          that = this;

      if (!targetEl) {
        return;
      }

      targetEl.innerHTML = "";
      var keepEditing = false,
          $input = $(document.createElement("input")),
          editFinished = function () {
            $(document.body).off(".mb-inplace-edit");
            options.model.unset("edit");
          },
          abortEvent = function (e) {
            if (e) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          cancel = function (e) {
            if (e && /key/i.test(e.type) && e.which !== 13) return;

            abortEvent(e);
            editFinished();
            options.model.trigger("change");
            dom.focus($targetEl, true);
          },
          update = function (e) {
            if (e && /key/i.test(e.type) && e.which !== 13 && !/input/i.test(e.target.tagName)) return;



            abortEvent(e);
            editFinished();

            var name = $input.val(),
                request;
            // return if value of input is only empty spaces
            if (!name.replace(/\s/g, '').length) {
              return;
            }

            if (name) {
              var nameTaken = options.model && options.model.collection && options.model.collection.isNameTaken(name, options.model);
              keepEditing = nameTaken;

              if (nameTaken) {
                alert(i18n("client_name_already_taken"));
                $input.focus();
              } else {
                if (options.model.get("name") !== name) {
                  options.model.set("name", name);
                } else {
                  options.model.trigger("change");
                }
                if (options.model.collection && options.model.collection.save) {
                  options.model.collection.save();
                }
                else if (options.model.collection) {
                  options.model.save();
                }
                dom.focus($targetEl, true);
              }
            } else {
              $targetEl.addClass("mb-inplace-editable");
              if (!keepEditing) {
                options.model.trigger("change");
              }
            }
          };

      $input.addClass("mb-inplace-edit");
      $input.attr("placeholder", options.model.get("name")); // => Bindung an Model
      $input.attr("aria-label", options.model.get("name"));

      $input.val(options.model.get("name"));
      $input.on("keydown", function (e) {
          if (e.keyCode === 13) { // Return
            update();
          } else if (e.keyCode === 27) { // ESC
            cancel();
          }
      });

      $input.on("click", function (e) {
          e.stopPropagation();
          e.preventDefault();
      });

      var editWrapperEl = document.createElement("span");
      editWrapperEl.className = "mb-inplace-edit-control";
      editWrapperEl.appendChild($input[0]);

      targetEl.removeAttribute("data-action-object");
      targetEl.removeAttribute("href");
      $targetEl.removeClass("mb-inplace-editable");
      $input.css("font", $targetEl.css("font"));
      $input.css("vertical-align", $targetEl.css("vertical-align"));
      _.defer(function () {
          $input.select();
      });

      var actionEl = document.createElement("span");
      actionEl.className = "mb-inplace-actions";

      var $ok = $('<button class="mb-btn-no-decor action mb-inplace-action" title="' + i18n("article_button_publish") + '">&nbsp;<i class="icon-ok-sign"></i></button>')
      $ok.on("click", update);
      $ok.on("keypress", update);
      actionEl.appendChild($ok[0]);
      var $cancel = $('<button class="mb-btn-no-decor action mb-inplace-action" title="' + i18n("Cancel") + '">&nbsp;<i class="icon-remove-sign"></i></button>')
      $cancel.on("click", cancel);
      $cancel.on("keypress", cancel);
      actionEl.appendChild($cancel[0]);
      if (options.deletable) {
        actionEl.appendChild($('<button class="mb-btn-no-decor action mb-inplace-action" title="' + i18n("action_delete") + '" data-action-object="' + _.escape(JSON.stringify({
                destroyModel: {}
              })) +
              '">&nbsp;<i class="icon-trash"></i></button>')[0]);
      }
      editWrapperEl.appendChild(actionEl);
      $(document.body).on("focusin.mb-inplace-edit click.mb-inplace-edit", function (e) {
        if (!dom.isChild(e.target, targetEl)) {
          $(document.body).off(".mb-inplace-edit");
        if(targetEl.parentElement&&targetEl.parentElement.parentElement) cancel();
        }
      });

      targetEl.appendChild(editWrapperEl);


    }
});
